const DISPLAYED_MEMBERS = {
  RESOURCE: 'RESOURCE',
  REVIEW: 'REVIEW'
};

export default DISPLAYED_MEMBERS;